// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Heading3-module__root--XXVMq {\n  font-size: var(--heading3FontSize);\n  font-weight: 500;\n  letter-spacing: 0.15px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/common/Heading3/Heading3.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":[".root {\n  font-size: var(--heading3FontSize);\n  font-weight: 500;\n  letter-spacing: 0.15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Heading3-module__root--XXVMq"
};
export default ___CSS_LOADER_EXPORT___;
